<template>
  <div>
    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-xl-12">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Başvuru Sil</h3>
                </div>
                <div class="col-lg-12 col-xs-12 mt-4">
                  <template>
                    <el-input id="company-name-input" class="form-control-alternative col-xl-2 col-xs-12  mr-3 mb-2"
                              v-on:input="eventText(search_key)"
                              placeholder="Başvuru ID"
                              type="text"
                              v-model="filterForm['search_name']">
                    </el-input>
                  </template>
                </div>
              </div>
            </div>


            <div class="table-responsive" v-loading="loading">
              <base-table thead-classes="thead-light"
                          :data="applications"
                          v-if="applications != null ">
                <template slot="columns">
                  <th>Id</th>
                  <th>Başvuran Adı Soyadı</th>
                  <th>İlan Adı</th>
                  <th>Başvuru Tarihi</th>
                  <th>Başvuru Sil</th>
                  <th></th>
                </template>
                <template slot-scope="{row}">

                  <td><span>{{row.id.toString()}}</span></td>
                  <td><span>{{ row.user.name}}</span></td>
                  <td>{{row.job.title}}</td>
                  <td>{{ row.created_at | fixDate }}</td>
                  <td>
                    <el-button split-button size="small" placement=""
                               type="danger"
                               @click="deleteApplication(index,row)">
                      <span> Başvuruyu Sil</span>
                    </el-button>
                  </td>
                </template>
              </base-table>
            </div>
            <div class="card-footer py-4 d-flex justify-content-between align-items-center">
              <small class="mb-0">Toplam: {{ total }}</small>
              <base-pagination v-model="currentPage" :total="total"></base-pagination>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as axios from "axios";

export default {
  name: 'Applications',
  data() {
    return {
      applications: [],
      vm: null,
      loading: true,
      company: [],
      search_key: "",
      followers: null,
      filter_expanded: false,
      offset: 0,
      limit: 0,
      pageSizes: [5, 10, 15, 30, 50],
      total: 0,
      filterForm: {},
      currentPageSize: 10,
      currentPage: 1,
      alphabeticalSortingValue: "",
      list_status: null,
      options: [{
        value: 'asc',
        label: 'A dan Z ye'
      }, {
        value: 'desc',
        label: 'Z den A ya'
      }]
    };
  },



  async mounted() {
    await this.getApplications();
  },

  async created() {
    let fullpath = this.$route.fullPath;
    await this.handleRouteChange(fullpath);

  },
  beforeRouteUpdate(to, from, next) {
    this.handleRouteChange(to.path);
    next();
  },
  watch: {
    currentPage: {
      handler: "paginate",
      immediate: true
    }
  },
  methods: {
    async handleRouteChange() {
      this.limit = this.currentPageSize;
      await this.getApplications();

    },
    getExactRoute(path) {
      let arr = path.split('/');
      return arr[arr.length - 1];
    },

    async eventText() {
      this.clearPagination();
      await this.getApplications();
    },

    async getApplications() {
      this.loading = true;
      const data = {
        offset: this.offset,
        limit: this.limit,
        list_status: this.list_status,
        filterForm: this.filterForm
      }
      let obj = this.filterForm;
      let additionalData = {};
      Object.keys(obj).forEach(function (key) {
        additionalData[key] = obj[key]['value'];
      });
      let postData = Object.assign(data, additionalData);
      axios.post('admin/applications', postData).then(response => {
        this.applications = response.data.results;
        this.total = response.data.new_request_requirements.total;
        this.followers = response.data.results;
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$notify.error({
          title: 'Bir hata meydana geldi',
          message: error.response.data.join(' ')
        });
      })
    },

    async deleteApplication(index,row) {
      await this.$confirm('Başvuruyu Silmek İstediğinize Emin Misiniz?', 'Dikkat!', {
        confirmButtonText: 'Sil',
        cancelButtonText: 'Vazgeç',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        // eslint-disable-next-line no-unused-vars
        await axios.delete('company/application-delete/' + row.id).then(response => {
          this.applications.splice(index,1);
          this.$notify.success({
            message: 'Başvuru Silindi'
          });
          this.getApplications();
        }).catch(function (error) {
          this.$notify.error({
            title: 'Silinemedi',
            message: error.response.data.join(' ')
          });

        });
        this.loading = false;
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Başvuru Silinemedi'
        });
      });
    },

    handleSizeChange(val) {
      this.currentPageSize = val;
      this.currentPage = 1;
      this.paginate();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.paginate();
    },
    async paginate() {
      this.offset = (this.currentPage - 1) * this.currentPageSize;
      this.limit = this.currentPageSize;
      await this.getApplications();
    },
    clearPagination() {
      this.currentPage = 1;
      this.offset = (this.currentPage - 1) * this.currentPageSize;
    }

  }
};
</script>

<style>
.pagi {
  color: green !important;

}
</style>
